import Mutations from '../../odata/mutations';

export default { ...new Mutations('moduleProcess'), ...new Mutations('moduleProcesses') };
